module.exports = __webpack_public_path__ + "img/kosmos-horiatiki.c172a278.jpg";